import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NgxUiLoaderConfig } from 'ngx-ui-loader';
import { ngxUiLoaderConfig } from './common/global';
import { LanguageService } from './service/language.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent {
  isOnline: boolean = navigator.onLine;

  config: NgxUiLoaderConfig;

  constructor(
    private translate: TranslateService,
    private _languageService: LanguageService) {
    this.config = ngxUiLoaderConfig;
    let language = 'es';

    const data = window.sessionStorage.getItem('50EE60E5468D8FC43984228303D24EE9');
    if (data) {
      let user = JSON.parse(data);
      if (user.language) {
        language = user.language;
      } else {
        const _language = this.translate.getBrowserLang();
        language = ['es','en'].includes(_language) ?  _language : 'es';
      }
    }
    else{
      if (sessionStorage.getItem('currentLang')) {
        language = sessionStorage.getItem('currentLang');
      } else {
        language = this.translate.getBrowserLang();
      }     
    }

    sessionStorage.setItem('currentLang', language);
    this.translate.use(language);

    
  }
}
